
export default class NotificationResult {
	id: string;
	customerId: string;
	customerApiKey: string;
	signOrderId: string;
	resultStatus: string;
	completedDate: string;
	CreatedAt: string;
	LastModified: string;
	eventLog: any;

	constructor(result: Partial<NotificationResult>) {
		Object.assign(this, result);
	}
}